@if (src) {
  @if (valid) {
    <img
      (error)="onError()"
      [ngClass]="['max-w-none', fullWidth ? 'w-full' : '']"
      [src]="src"
      [style]="{ height: height + 'px!important' }"
      class="object-cover"
    />
  }
  @if (!valid) {
    <div
      [ngClass]="[
      'm-1',
      'p-1',
      border ? 'border' : '',
      'flex',
      'justify-center',
      'items-center',
      'text-center',
      fullWidth ? '' : 'inline-block'
    ]"
      [title]="'Chyba při načítání z URL [' + src.substring(0, 30) + ']'"
    >
      <mat-icon
      >warning
      </mat-icon>
    </div>
  }
}
